// extracted by mini-css-extract-plugin
export default {"headerContainer":"betKalkulatori_headerContainer__py3WI","contentWrapper":"betKalkulatori_contentWrapper__6V8DG","textContainer":"betKalkulatori_textContainer__OXvqb"};